import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Clock, Users, Star, ArrowRight } from "lucide-react";
import SiteMasthead from "@/cms/SiteMasthead";
import { EXPERIENCES } from "@/data/experienceData";

export default function ExquraExperience() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <SiteMasthead />

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-[#0B2421]">Exqura Experiences</h1>
          <p className="text-sm text-gray-400 mt-1">Showing {EXPERIENCES.length} curated experiences</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {EXPERIENCES.map((exp, i) => (
            <motion.div
              key={exp.id}
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.08 }}
              className="rounded-xl overflow-hidden shadow-md bg-white border border-gray-100 flex flex-col cursor-pointer group"
              onClick={() => navigate(`/experience-detail?id=${exp.id}`)}
            >
              {/* Square image */}
              <div className="relative aspect-square overflow-hidden">
                <img
                  src={exp.image}
                  alt={exp.name}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                {exp.badge && (
                  <span className={`absolute top-3 left-3 ${exp.badgeColor} text-white text-xs font-bold px-2.5 py-1 rounded-md`}>
                    {exp.badge}
                  </span>
                )}
                <div className="absolute top-3 right-3 flex items-center gap-1 bg-black/40 backdrop-blur-sm px-2 py-1 rounded-full">
                  <Star className="w-3 h-3 text-[#D4AF37] fill-[#D4AF37]" />
                  <span className="text-white text-xs font-semibold">{exp.rating}</span>
                </div>
              </div>

              {/* Content */}
              <div className="p-4 flex flex-col gap-2 flex-1 bg-gray-50">
                <h2 className="text-[#0B2421] font-bold text-base">{exp.name}</h2>
                <p className="text-[#D4AF37] text-xs font-semibold">{exp.tagline}</p>
                <p className="text-gray-500 text-xs leading-relaxed flex-1">{exp.description}</p>

                <div className="flex items-center gap-3 text-gray-400 text-xs pt-1">
                  <span className="flex items-center gap-1"><Clock className="w-3 h-3" />{exp.duration}</span>
                  <span className="flex items-center gap-1"><Users className="w-3 h-3" />{exp.players}</span>
                </div>

                <div className="flex items-center justify-between pt-3 border-t border-gray-200 mt-1">
                  <div>
                    <p className="text-[10px] text-gray-400">From</p>
                    <p className="text-[#0B2421] font-bold text-lg leading-none">
                      SGD {exp.price}<span className="text-xs font-normal text-gray-400"> per player</span>
                    </p>
                  </div>
                  <button
                    onClick={(e) => { e.stopPropagation(); navigate(`/experience-detail?id=${exp.id}`); }}
                    className="flex items-center gap-1.5 bg-[#0B2421] hover:bg-[#0B2421]/85 text-white text-sm font-semibold px-4 py-2.5 rounded-lg transition-colors"
                  >
                    Book <ArrowRight className="w-3.5 h-3.5" />
                  </button>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
